const placementPrefix = 'placement';
const globalPrefix = 'global';
const facilityPrefix = 'facility';
const placementMarginToolPrefix = 'placementMarginTool';

export const PromiseTrackerKeys = {
  placements: {
    peopleSoftSync: `${placementPrefix}-sync-placement-with-peoplesoft`,
    peopleSoftGetDetails: `${placementPrefix}-get-placement-peoplesoft-status`,
    peopleSoftAwaitResults: `${placementPrefix}-get-placement-peoplesoft-results-delayed`,
    updateAllDetails: `${placementPrefix}-update-placement-details`,
    mergeTokens: `${placementPrefix}-candidate-contract-templates-merge-tokens`,
    contractCatalogTemplates: `${placementPrefix}-candidate-contract-catalog-templates`,
    contractTemplateRows: `${placementPrefix}-candidate-contract-template-rows`,
    generateDraft: `${placementPrefix}-candidate-contract-templates-generate-draft`,
    deleteDraft: `${placementPrefix}-candidate-contract-templates-delete-draft`,
    previewDocument: `${placementPrefix}-client-contract-templates-preview-document`,
    createDocument: `${placementPrefix}-client-contract-templates-create-document`,
    saveDraft: `${placementPrefix}-candidate-contract-templates-save-draft`,
    publishDocument: `${placementPrefix}-client-contract-templates-publish-document`,
    tscPublishDocument: `${placementPrefix}-candidate-contract-tsc-publish-document`,
    voidDocument: `${placementPrefix}-client-contract-templates-void-document`,
    requestPdfDoc: `${placementPrefix}-candidate-contract-request-pdf-doc`,
    contractStatusUpdate: `${placementPrefix}-candidate-contract-status-update`,
    updateOrderId: `update-orderId-placement`,
    getModifications: 'get-pending-modifications',
    bulkUpdateMods: 'bulk-save-pending-mods',
    bulkDeleteMods: 'bulk-delete-pending-mods',
  },
  global: {
    optimizelyFlags: `${globalPrefix}-optimizely-flags`,
    optimizelyFlagVariation: `${globalPrefix}-optimizely-flag-variation`,
    searchCall: `${globalPrefix}-search-call`,
  },
  facility: {
    facilitiesForAffiliate: `${facilityPrefix}-get-facilities-for-affiliate`,
  },
  placementMarginTool: {
    peopleSoftCallMarginTool: `${placementMarginToolPrefix}-get-people-soft-calculation`,
    updateScnarioCalculatedValues: `${placementMarginToolPrefix}-get-calculation-update`,
    peopleSoftCallMarginToolProgress: `${placementMarginToolPrefix}-get-people-soft-calculation-in-progress`,
    gsaCalculateFetchData: `${placementMarginToolPrefix}-get-scenario-gsa-calculate-data`,
    getAddScenarioDetailsFetchData: `${placementMarginToolPrefix}-get-scenario-add-details-data`,
    getAddScenarioExtensionDetailsFetchData: `${placementMarginToolPrefix}-get-scenario-extension-add-details-data`,
    initialMarginToolsData: `${placementMarginToolPrefix}-get-initial-margin-tools-data`,
    scenarioNavigationData: `${placementMarginToolPrefix}-get-scenario-navigation-tree-data`,
    marginToolTemplate: `${placementMarginToolPrefix}-get-margin-tool-template`,
    fetchplacementHeader: `${placementMarginToolPrefix}-get-margin-tool-placement-header`,
    fetchOrderDetails: `${placementMarginToolPrefix}-get-margin-tool-order-details`,
    fetchPlacementDocs: `${placementMarginToolPrefix}-get-margin-tool-placement-docs`,
    fetchBillRateMod: `${placementMarginToolPrefix}-get-margin-tool-bill-rate-mod`,
    marginToolPreview: `${placementMarginToolPrefix}-get-margin-tool-preview`,
    saveScenario: `${placementMarginToolPrefix}-save-scenario`,
    validateScenario: `${placementMarginToolPrefix}-validate-scenario`,
    updateScenarioStatus: `${placementMarginToolPrefix}-update-pay-package-status-update`,
  },
};
